import { createElement } from 'react'
import { withRouter } from 'react-router'
import pick from 'lodash/pick'

const storageKey = 'event-redirect-url'
const ttl = 10 * 60 // seconds

export const registerEventRedirect = (history, event) => {
  const location = pick(history.location, 'pathname', 'search')
  const data = { event, location, time: (new Date()).getTime() }
  window.sessionStorage.setItem(storageKey, JSON.stringify(data))
}

export const performEventRedirect = (history, event) => {
  let location
  try {
    const storageItem = window.sessionStorage.getItem(storageKey)
    const data = JSON.parse(storageItem)
    if (event !== data.event) return false
    if (data.time + (ttl * 1000) < (new Date()).getTime()) return false;
    ({ location } = data)
  } catch (e) {
    // do nothing
  }
  window.sessionStorage.removeItem(storageKey)
  if (location) history.push(location)
  return !!location
}

export const RegisterEventRedirectOnClick = withRouter(
  ({ component, event, onClick, history, match, location, staticContext, ...rest }) => (
    createElement(component, {
      ...rest,
      onClick: (ev) => {
        registerEventRedirect(history, event)
        if (onClick) onClick(ev)
      }
    })
  )
)
